import React from 'react';
import { Link } from 'react-router-dom';

/**
 * 404 Not Found Page Component
 */
const NotFoundPage: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="text-center">
        <h1 className="text-9xl font-bold text-primary-600">404</h1>
        <h2 className="text-3xl font-semibold text-gray-900 mt-4 mb-2">
          Page not found
        </h2>
        <p className="text-lg text-gray-600 mb-8">
          Sorry, we couldn't find the page you're looking for.
        </p>
        <Link
          to="/dashboard"
          className="btn btn-primary"
        >
          Go back home
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
